import { API } from "../../../config";
import { LIST_LIMIT } from "../../../constants/constants";
import { DemoCategoryListWithPaginationType } from "../../../interfaces/DemoCategoryListInterface";
import { DemoStuckedTransctionLogWithPaginationType } from "../../../interfaces/DemoStuckedTransctionInterface";
import { DemoUsersWithPaginationType } from "../../../interfaces/DemoUserinterface";
import AxiosUtils from "../../../utils/AxiosUtils";
import Cookies from "../../../utils/Cookies";
import { mockAPIPath, serverAPIPath } from "../config/apiPath";
 
class DemoUserService {
    private payload: object;
    private isHitDummyURL: boolean;
    private headers: object;
 
    constructor(payload = {}, isHitDummyURL = false) {
        this.payload = payload;
        this.isHitDummyURL = isHitDummyURL;
        this.headers = { "access-token": new Cookies("access-token").read(),"accept-language":process.env.REACT_APP_LANGUAGE };
    }
 
    async demoUserList(
        page_id: number,
        limit = LIST_LIMIT.DEMO_STORE_LIST_LIMIT,
        search:string,
        column? : any,
        order?:string
    ) {
        const response = this.isHitDummyURL
            ? await new AxiosUtils(
                `${mockAPIPath.DEMO_USER_LIST}`,
                this.payload
            ).get()
            : await new AxiosUtils(
                `${API.BASE_URL}${serverAPIPath.DEMO_USER_LIST}?page=${page_id}&limit=${limit}&search=${search}&column=${column}&order=${order}`,
                this.payload,
                this.headers
            ).get();
        if (response?.data?.success) {
            const { currentPage, totalPages, currentTotalCount, totalCount} = response.data.data;
            const DemoUserListData: DemoUsersWithPaginationType  = {
                demoUsersLogs: response.data.data.data,
                pagination: {
                    totalPages,
                    currentPage,                  
                    currentTotalCount,
                    totalCount,
                },
            };
            
            return DemoUserListData;
        } else if (response?.success == false) {
            throw new Error(response?.message);
        } else {
            throw new Error(response);
        }

        

    }

    async inviteDemoUser(){
        const response = await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.DEMO_USER_INVITATION}`, this.payload, this.headers).post();
        let isUserIvited;
        if(response?.data?.success==true) {
            isUserIvited = response?.data;
            return isUserIvited;
        }
        else if(response?.success == false)
        {   
            throw new Error(response?.message);        
        }else{
            throw new Error(response);
        }
    }
    async createDemoUser(){
        const response = await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.CREATE_DEMO_USER}`, this.payload, this.headers).post();
        let isUserIvited;
        if(response?.data?.success==true) {
            isUserIvited = response?.data;
            return isUserIvited;
        }
        else if(response?.success == false)
        {   
            throw new Error(response?.message);        
        }else{
            throw new Error(response);
        }
    }
    async revokeUser(){
        const response = await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.REVOKE_DEMO_USER}`, this.payload, this.headers).post();
        let isUserRevoked;
        if(response?.data?.success==true) {
            isUserRevoked = response?.data;
            return isUserRevoked;
        }
        else if(response?.success == false)
        {   
            throw new Error(response?.message);        
        }else{
            throw new Error(response);
        }
    }


    async demoStuckedTransctionList(
        page_id: number,
        limit = LIST_LIMIT.STUCKED_TRANSACTION_LIMIT,
    ) {
        const response = this.isHitDummyURL? await new AxiosUtils(`${mockAPIPath.DEMO_STUCK_TRANSACTION}`, this.payload).get() 
            : await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.DEMO_STUCK_TRANSACTION}?page=${page_id}&limit=${limit}`, this.payload, this.headers).get();
      
        if (response?.data?.success) {
            const { data, currentPage, totalPages, currentTotalCount, totalCount } =  response.data.data; 
            const demoStuckedTransactionData: DemoStuckedTransctionLogWithPaginationType  = {
                demoStuckedTransctionLogs: data,
                pagination: {
                    currentPage,
                    totalPages,
                    currentTotalCount,
                    totalCount,
                },
            };
            return demoStuckedTransactionData;
        } else if (response?.success == false) {
            throw new Error(response?.message);
        } else {
            throw new Error(response);
        }
    }
    async deleteDemoStuckedTransction(
        id:number,
        storeId: number,
    ) {
        const response = this.isHitDummyURL? await new AxiosUtils(`${mockAPIPath.DELETE_DEMO_STUCKED_TRANSACTION}`+ storeId, this.payload, this.headers).delete() 
            : await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.DELETE_DEMO_STUCKED_TRANSACTION}`, this.payload, this.headers).delete();
      
        let responeMessage: string;
        if(response?.data?.success==true) {
            responeMessage = response?.data?.message;
            return responeMessage;
        }
        else if(response?.success == false)
        {   
            throw new Error(response?.message);        
        }else{
            throw new Error(response);
        }
    }
 
}
 
export default DemoUserService;